module.exports = require('./lib/html-to-text');
